/**
 * @module lib/audience/propensity
 */
import logger from "utils/logger";
import { getProp } from "utils/utils";

const debugTag = "[PROPENSITY]";

/**
 * We need this to test users that are about to churn.
 * @param {Object} [propensity={}] - of user's propensity to churn
 * @param {String} [search=window.location.search] - to check for debug flag
 * @returns {Object}
 */
export function debugChurn(propensity, search = window.location.search) {
  const assignChurn = /churn=true/.test(search);
  if (!assignChurn) {
    return propensity;
  }
  const churn = {
    PREMIUM: {
      churn: 1
    }
  };
  logger.log(`${debugTag} debug:`, churn);
  return churn;
}

/**
 * Determine if the current user has propensity to churn.
 * @param {Object} config - TGAM config object
 * @returns {Boolean}
 */
export function userHasChurn(config = {}) {
  const propensity = getProp(config, "datalayer.identity.propensity.PREMIUM.churn", 0);
  const userToChurn = [1, 2, 3].includes(propensity);
  logger.log(`${debugTag} userHasChurn:`, userToChurn);
  return userToChurn;
}
